//#region src/components/file-drop-zone/constants.ts
var e = /* @__PURE__ */ function(e) {
	return e[e.Small = 0] = "Small", e[e.Medium = 1] = "Medium", e[e.Big = 2] = "Big", e;
}({}), t = {
	0: "p-4",
	1: "p-6",
	2: "min-h-50 p-6"
};
//#endregion
export { e as FileDropZoneVariantEnum, t as variantClassName };
